/* eslint-disable import/no-mutable-exports */
import React from 'react';

type WithSafeTimeout = <T>(Component: T) => T;
type SafeTimeout = (
  handler: (...params: any[]) => any,
  timeout?: number,
  ...args: any[]
) => void;
type InjectedSafeTimeout = { safeTimeout: SafeTimeout };

let withSafeTimeout = WrappedComponent =>
  class extends React.Component {
    timeouts: number[] = [];

    componentWillUnmount() {
      this.timeouts.forEach(timeout => {
        clearTimeout(timeout);
      });
    }

    safeTimeout = (handler, timeout, ...args) => {
      const timeoutID = window.setTimeout(handler, timeout, ...args);

      this.timeouts.push(timeoutID);
    };

    render() {
      return (
        <WrappedComponent {...this.props} safeTimeout={this.safeTimeout} />
      );
    }
  };

withSafeTimeout = withSafeTimeout as WithSafeTimeout;

export { withSafeTimeout, SafeTimeout, InjectedSafeTimeout };
